export let PaymentsEnrollmentIframeMessageType;
(function (PaymentsEnrollmentIframeMessageType) {
  PaymentsEnrollmentIframeMessageType["SHOW_FALLBACK_MODAL"] = "SHOW_FALLBACK_MODAL";
  PaymentsEnrollmentIframeMessageType["SHOW_SUCCESS_MODAL"] = "SHOW_SUCCESS_MODAL";
  PaymentsEnrollmentIframeMessageType["SHOW_CANCEL_MODAL"] = "SHOW_CANCEL_MODAL";
  PaymentsEnrollmentIframeMessageType["SHOW_CANCEL_SURVEY"] = "SHOW_CANCEL_SURVEY";
  PaymentsEnrollmentIframeMessageType["REDIRECT"] = "REDIRECT";
  PaymentsEnrollmentIframeMessageType["SHOW_OAUTH_ONBOARDING_SUCCESS_MODAL"] = "SHOW_OAUTH_ONBOARDING_SUCCESS_MODAL";
  PaymentsEnrollmentIframeMessageType["CLOSE_EMBEDDED_ONBOADING"] = "CLOSE_EMBEDDED_ONBOADING";
})(PaymentsEnrollmentIframeMessageType || (PaymentsEnrollmentIframeMessageType = {}));